import ReviewInfoCapsule from './ReviewInfoCapsule';

export default ReviewInfoCapsule;
